import { InjectionToken } from '@angular/core';
import { AuthConfig } from '../../models/config/auth-config.interface';

export const AUTH_CONFIG = new InjectionToken<AuthConfig>('Auth Config');
